import { customerThemeOptionsWithDatepicker as mdsThemeOptions, } from '@mehilainen/mds-core/theme-datepicker';
import { createTheme } from '@mui/material';
import pick from 'lodash/pick';
import { breakpoints } from './breakpoints';
import { typography } from './typography';
// Override MDS theme here if needed
export const themeOptions = Object.assign(Object.assign({}, mdsThemeOptions), { breakpoints,
    typography });
export const theme = createTheme(themeOptions);
export const getPartialTheme = (...keys) => createTheme(Object.assign(Object.assign({}, themeOptions), { components: Object.assign({}, pick(themeOptions.components, keys)) }));
